import gql from 'graphql-tag'

export default gql`
mutation printLabelJandt($trackingId: String!) {
  printLabelJandt(trackingId: $trackingId) {
    _id
    labelUrl
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/printLabelJandt.js